import { msg } from 'gt-react';
import { ClockCounterClockwiseIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const ActivityLogPage = lazyRouteComponent(
  () => import('./ActivityLogPage'),
  'ActivityLogPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/activity-log',
  staticData: {
    app: {
      nav: {
        label: msg('Activity Log', {
          context: 'sidebar nav label, Ship and Debit Admin section',
        }),
        icon: <ClockCounterClockwiseIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit Admin',
        order: 20,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.SDAdmin }],
      },
    },
  },
  component: ActivityLogPage,
  loader: () => ({
    crumb: msg('Activity Log', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SDAdmin,
    });
  },
});
